import * as React from 'react'

const ContextMenuIcon = (props: { className: string }) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='3'
      height='16'
      viewBox='0 0 3 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 1.5C3 1.86279 2.87109 2.19531 2.65723 2.45459C2.38184 2.7876 1.96582 3 1.5 3C0.671875 3 0 2.32861 0 1.5C0 1.18457 0.0976562 0.891602 0.263672 0.649902C0.53418 0.257324 0.987305 0 1.5 0C2.05957 0 2.54785 0.306641 2.80566 0.76123C2.92969 0.979004 3 1.23145 3 1.5ZM3 8C3 8.229 2.94922 8.4458 2.85742 8.64014C2.61719 9.14844 2.09961 9.5 1.5 9.5C1.02734 9.5 0.605469 9.28125 0.331055 8.93994C0.124023 8.68262 0 8.35596 0 8C0 7.17139 0.671875 6.5 1.5 6.5C1.88574 6.5 2.2373 6.64551 2.50293 6.88477C2.80762 7.15918 3 7.55713 3 8ZM1.5 16C2.32812 16 3 15.3286 3 14.5C3 13.6714 2.32812 13 1.5 13C0.671875 13 0 13.6714 0 14.5C0 14.918 0.170898 15.2959 0.446289 15.5679C0.717773 15.835 1.08984 16 1.5 16Z'
        fill='#8C97A2'
      />
    </svg>
  )
}

export default ContextMenuIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/ContextMenu.tsx